import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=bfb8176e&scoped=true&"
import script from "./CustomerDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb8176e",
  null
  
)

export default component.exports